import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Box, Fade, Grid } from '@mui/material';
import BackForwardNav from '../../FileManager/FilesContainer/BackForwardNav';
import { FileManagerInventoryFile } from '../../../redux/slices/slice_types';
import { selectCurrentPath, selectLastOpenedPendingAssetLoaction } from '../../../redux/selectors/fileManagerSelectors';
import { getFileSources, getFolder, resetFileManager } from '../../../redux/slices/fileManagerSlice';
import FolderContent from '../../FileManager/FilesContainer/FolderContent/FolderContent';
import FileNavigationContainer from '@/components/FileManager/FilesContainer/FileNavigation/FileNavigationContainer';
import Path from '@/components/FileManager/FilesContainer/Path/Path';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

interface FileBrowserProps {
  onFileSelect: (file: FileManagerInventoryFile) => void;
}

const FileBrowser = ({ onFileSelect }: FileBrowserProps) => {
  const dispatch = useAppDispatch();
  const lastLocation = useAppSelector(selectLastOpenedPendingAssetLoaction);
  const currentPath = useAppSelector(selectCurrentPath) || [];

  useEffect(() => {
    dispatch(getFileSources());
    if (lastLocation) dispatch(getFolder({ path: lastLocation }));
    return () => {
      dispatch(resetFileManager());
    };
  }, []);

  return (
    <Fade in timeout={500}>
      <Box sx={{ mt: 2 }}>
        <Grid container alignItems="center" wrap="nowrap" pl={2.5}>
          <BackForwardNav />
          <Grid item>
            <Path withHome />
          </Grid>
        </Grid>

        <FileBrowserContent>{!currentPath?.length ? <FileNavigationContainer /> : <FolderContent addAction={onFileSelect} />}</FileBrowserContent>
      </Box>
    </Fade>
  );
};
export default FileBrowser;

const FileBrowserContent = styled.div`
  overflow: auto;
  height: 50vh;
  min-height: 300px;
  flex: auto;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.palette.action.selected};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  margin-top: ${({ theme }) => theme.spacing(1)};

  .MuiList-root {
    height: 100%;
    background: ${({ theme }) => theme.palette.background.default};

    .MuiListItemButton-root.Mui-selected {
      background: ${({ theme }) => theme.palette.action.focus};
    }
  }
`;
